/* eslint-disable no-console */
import Background from 'Components/Reusable/Background/Background';
import OverlapCard from 'Components/Reusable/Cards/OverlapCard';
import React, { Fragment, useEffect } from 'react';
import sittingBear from 'Assets/img/svg/icons/sittingBear.svg';
import { information } from 'Utils/information';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useHistory, useParams } from 'react-router-dom';
import { Routes } from 'Utils/Route';
import { useDispatch, useSelector } from 'react-redux';
import { getMilestoneCategories } from 'ReduxStore/milestones/Action';
import { RootState } from 'ReduxStore';
import { changeIdentities } from 'Helpers';
import { GetAllKids } from 'ReduxStore/children/Action';
interface RouteParams {
	id: string;
}

const Congratulations = () => {
	// const navigate = useNavigate();

	// // eslint-disable-next-line no-console
	// console.log(navigate(-1));
	const matches = useMediaQuery('(max-width:768px)');
	const history = useHistory();
	console.log(history);
	const params = useParams<RouteParams>();
	const onClick = () => {
		history.push(Routes.Menu);
		return window.location.reload();
	};
	const dispatch = useDispatch();
	const children = useSelector((state: RootState) => state.children.children);

	useEffect(() => {
		dispatch(getMilestoneCategories());
		dispatch(GetAllKids());
	}, []);
	const getChildId = params.id;
	const child = children && children.find(child => child.id === parseInt(getChildId));
	return (
		<Fragment>
			<Background backgroundColor="#FEDA37" height={matches ? 'auto' : '100vh'}>
				<OverlapCard
					image={sittingBear}
					heading={information.cards.heading}
					subheading={information.cards.subheading}
					information={changeIdentities(information.cards.info, child?.fullName, child?.gender)}
					common={{ margin: '-5rem auto 2rem', width: '80%' }}
					next
					onClick={onClick}
					upper
				/>
			</Background>
		</Fragment>
	);
};

export default Congratulations;
